module.exports = __webpack_public_path__ + "img/businessScopeImg5.53d79fc3.png";